module.exports = __webpack_public_path__ + "static/media/button-gradient-01.cffa8783.svg";